class TmlHomeHeader extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.trigger = this.querySelector('[data-menu-trigger]');
    this.drawer = this.querySelector('[data-menu-drawer]');

    this.handleToggle = this.handleToggle.bind(this);
    this.handleDocumentPointer = this.handleDocumentPointer.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleViewportChange = this.handleViewportChange.bind(this);
    this.updateHeaderMetrics = this.updateHeaderMetrics.bind(this);

    this.trigger?.addEventListener('click', this.handleToggle);
    this.drawer?.addEventListener('click', (event) => {
      if (event.target.closest('a')) this.setOpen(false);
    });
    document.addEventListener('pointerdown', this.handleDocumentPointer);
    document.addEventListener('keydown', this.handleKeydown);
    window.addEventListener('resize', this.handleViewportChange, { passive: true });

    this.resizeObserver = new ResizeObserver(this.updateHeaderMetrics);
    this.resizeObserver.observe(this);

    const headerGroup = this.closest('#header-group');
    if (headerGroup) this.resizeObserver.observe(headerGroup);

    this.updateHeaderMetrics();
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.handleToggle);
    document.removeEventListener('pointerdown', this.handleDocumentPointer);
    document.removeEventListener('keydown', this.handleKeydown);
    window.removeEventListener('resize', this.handleViewportChange);
    this.resizeObserver?.disconnect();
  }

  handleToggle() {
    this.setOpen(this.dataset.open !== 'true', true);
  }

  handleDocumentPointer(event) {
    if (this.dataset.open !== 'true' || this.contains(event.target)) return;
    this.setOpen(false);
  }

  handleKeydown(event) {
    if (event.key !== 'Escape' || this.dataset.open !== 'true') return;
    this.setOpen(false, true);
  }

  handleViewportChange() {
    if (window.innerWidth >= 990 && this.dataset.open === 'true') this.setOpen(false);
    this.updateHeaderMetrics();
  }

  setOpen(open, moveFocus = false) {
    this.dataset.open = String(open);
    this.trigger?.setAttribute('aria-expanded', String(open));
    this.trigger?.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    this.drawer?.setAttribute('aria-hidden', String(!open));

    if (open && moveFocus) {
      requestAnimationFrame(() => this.drawer?.querySelector('a')?.focus());
    } else if (!open && moveFocus) {
      this.trigger?.focus();
    }
  }

  updateHeaderMetrics() {
    const headerGroup = this.closest('#header-group');
    const headerHeight = Math.round(this.getBoundingClientRect().height);

    document.body.style.setProperty('--header-height', `${headerHeight}px`);

    if (headerGroup) {
      const groupHeight = Math.round(headerGroup.getBoundingClientRect().height);
      document.body.style.setProperty('--header-group-height', `${groupHeight}px`);
    }
  }
}

if (!customElements.get('tml-home-header')) {
  customElements.define('tml-home-header', TmlHomeHeader);
}
